import Carousel from 'react-bootstrap/Carousel';
import InfoCard from './InfoCardSocionics';
function TidBitsCard(props) {
  return (
   <Carousel variant="dark" >
        <Carousel.Item>
          <InfoCard body={props.body} tidbit={true} p1={props.p1} difficult={props.difficult}/>
          </Carousel.Item>
          {props.p2 ? <Carousel.Item>
          <InfoCard body={props.body2} tidbit={true} p1={props.p2} difficult={props.difficult2}/>
       </Carousel.Item> :<div><br></br><br></br></div>}
    </Carousel>
  );
}

export default TidBitsCard;